
































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import { formatDateTimeSendApi } from '@/utils/common'
import Theme from '@/styles/Theme'
import _ from 'lodash'

@Component

export default class ComponentRecebimentoFiltro extends Vue {
  range?: any = {}

  numeroAtendimentoSearch: string = ''

  get getRange() {
    return this.range
  }

  set getRange(value) {
    this.range = value
    let start = ''
    if (value) {
      start = formatDateTimeSendApi(value.start)
    }

    let end = ''
    if (value) {
      end = formatDateTimeSendApi(value.end)
    }

    this.getRecebimentoStore.setPeriodoInicio(start)
    this.getRecebimentoStore.setPeriodoFinal(end)
    if (this.getRecebimentoStore.recebimentoFiltro.contratoId) {
      this.loadRecebimentoItens('filtro-data')
    }
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getTheme() {
    return Theme
  }

  get getRequestMessage() {
    return this.getRecebimentoStore.requestMessage
  }

  get getModalRecebimento() {
    return this.getRecebimentoStore.modalRecebimento.detalhes
  }

  get getNumeroAtendimentoSearch() {
    return this.numeroAtendimentoSearch
  }

  set getNumeroAtendimentoSearch(value) {
    this.numeroAtendimentoSearch = value
    this.getRecebimentoStore.setNumeroAtendimentoFiltro(value)
  }

  async loadRecebimentoItens(filterName) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getRecebimentoStore.clearRecebimentoItens()
    await this.getRecebimentoStore.loadRecebimentoItens()
    this.clearLoadingRequest()
    this.ga(filterName)
  }

  async clear(input: string) {
    this.getRecebimentoStore.recebimentoFiltro[input] = ''
    this.loadRecebimentoItens(`filter-clear-${input}`)
  }

  async clearNumeroAtendimento() {
    this.getNumeroAtendimentoSearch = ''
    this.loadRecebimentoItens('filter-clear-atendimento')
  }

  clearFieldText() {
    this.getNumeroAtendimentoSearch = ''
  }

  clearRange() {
    this.range = null
  }

  async loadFiltro() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getRecebimentoStore.clearRecebimentoItens()
    await this.getRecebimentoStore.loadRecebimentoItens()
    this.clearLoadingRequest()
  }

  debounce = _.debounce(input => this.loadRecebimentoItens('filtro-numero-atendimento'), 600)

  search(input) {
    if (!this.getNumeroAtendimentoSearch
      || this.getNumeroAtendimentoSearch.length === 0
      || this.getNumeroAtendimentoSearch.length > 2) {
      this.debounce(this.getNumeroAtendimentoSearch)
    }
  }

  ga(filtroItem) {
    this.$ga.event('recebimento', filtroItem, this.$user.profile.email)
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }
}
